import { SyntaxHighlighter } from '@/components/ui/syntax-highlighter';
import { END_POINT_LLM_SERVICE_CHAT } from '@/constants';

type CodeSnippetProps = {
  model: string;
  apiKey?: string;
  endpoint?: string;
};
const CodeCurl = ({
  model,
  apiKey = '<your API key>',
  endpoint = END_POINT_LLM_SERVICE_CHAT,
}: CodeSnippetProps) => {
  return (
    <div className="flex flex-col gap-2">
      <p>To quickly try the API using cURL, use the following command:</p>
      <SyntaxHighlighter language="bash" wrapLongLines showCopy>
        {`curl -X POST ${endpoint} \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer ${apiKey}" \\
  -d '{
    "model": "${model}",
    "messages": [
      {
        "role": "system",
        "content": "You are a helpful assistant."
      },
      {
        "role": "user",
        "content": "สวัสดี"
      }
    ]
   }'
 `}
      </SyntaxHighlighter>
    </div>
  );
};

export default CodeCurl;
